/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './saluation.reducer';

export const SaluationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const saluationEntity = useAppSelector(state => state.saluation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="saluationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.saluation.detail.title">Saluation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.saluation.id">Id</Translate>
            </span>
          </dt>
          <dd>{saluationEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.saluation.description">Description</Translate>
            </span>
          </dt>
          <dd>{saluationEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.saluation.active">Active</Translate>
            </span>
          </dt>
          <dd>{saluationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.saluation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{saluationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.saluation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{saluationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.saluation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{saluationEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.saluation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{saluationEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/saluation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/saluation/${saluationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SaluationDetail;
